<template>
  <div class="proposition-info">
    <div
      v-if="documentLinks.length"
      class="proposition-info__section proposition-info__section--documents"
    >
      <ul class="proposition-info__list">
        <li
          v-for="(link, index) in documentLinks"
          :key="`document-link-${index}`"
          class="proposition-info__item"
        >
          <a
            :href="link.url"
            target="_blank"
            class="proposition-info__document-link"
          >
            {{ link.title }}
            <OpenDownIcon
              class="proposition-info__document-icon"
              color="#0A77FF"
            />
          </a>
        </li>
      </ul>
    </div>

    <ProductDescription :description="description" />
  </div>
</template>

<script>
import { OpenDownIcon } from '@/shared/ui/icons';
import { ProductDescription } from '@/shared/ui/insurance';

export default {
  props: {
    documentLinks: {
      type: Array,
      default: () => [],
    },
    description: {
      type: String,
      default: null,
    },
  },
  components: { OpenDownIcon, ProductDescription },
};
</script>

<style scoped lang="scss">
.proposition-info {
  &__section {
    margin-bottom: 24px;

    &:last-child {
      margin-bottom: 0;
    }
  }

  &__subtitle {
    font-size: 14px;
    font-weight: 600;
    color: #09090b;
    margin-bottom: 12px;
  }

  &__list {
    list-style: none;
    margin: 0;
    padding: 0;
  }

  &__item {
    & + & {
      margin-top: 8px;
    }
  }

  &__document-link {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 14px;
    font-weight: 400;
    color: #313437;
    background-color: #fafafa;
    border-radius: 8px;
    padding: 12px 16px;

    &:hover {
      background-color: #f2f2f2;
    }
  }

  &__document-icon {
    transform: rotate(-90deg);
  }

}
</style>
